<p>solution-rating works!</p>
